<template>
  <b-card
    v-if="data"
    no-body
    class="back border border-secondary"
  >
    <b-card-header>
      <b-card-title
        class="ml-25"
      >

        Alarm Durum Raporu
        <feather-icon
          icon="AlertCircleIcon"
          size="23"
          class="text-muted cursor-pointer"
        />
      </b-card-title><hr>
    </b-card-header>

    <!-- timeline -->
    <b-card-body>
      <app-timeline>
        <app-timeline-item variant="success">
          <div class="d-flex justify-content-between flex-sm-row flex-column mb-sm-0 mb-1">
            <h6>Sayaç No: 452668</h6>
            <small class="timeline-item-time text-nowrap text-muted ml-1">5 dk Önce</small>

          </div>
          <span>Başarılı</span>

          <b-media no-body>
            <b-media-aside class="mr-1">
              <b-img />
            </b-media-aside>
          </b-media>
        </app-timeline-item>

        <app-timeline-item variant="success">
          <div class="d-flex justify-content-between flex-sm-row flex-column mb-sm-0 mb-1">
            <h6>Sayaç No : 4562455</h6>
            <small class="timeline-item-time text-nowrap text-muted ml-1">35 dk Önce</small>
          </div>
          <p>Başarılı</p>
          <b-media no-body>
            <b-media-aside class="mr-50" />
            <b-media-body class="my-auto" />
          </b-media>
        </app-timeline-item>

        <app-timeline-item variant="primary">
          <div class="d-flex justify-content-between flex-sm-row flex-column mb-sm-0 mb-1">
            <h6>Sayaç No: 4235886</h6>
            <small class="timeline-item-time text-nowrap text-muted ml-1">2 gün Önce</small>
          </div>
          <a href="/forms/form-validation">
            <p class="online">
              Veri Alınması Bekleniyor
            </p></a>
          <b-avatar-group size="0">
            <b-avatar />
          </b-avatar-group>
        </app-timeline-item>
        <app-timeline-item
          variant="danger"
        >
          <div class="d-flex justify-content-between flex-sm-row flex-column mb-sm-0 mb-1">
            <h6>Sayaç No: 4235886</h6>
            <small class="timeline-item-time text-nowrap text-muted ml-1">3 gün Önce</small>
          </div>
          <a href="/forms/form-validation">
            <p
              class="online"
              style="color:red;"
            >
              Bağlantı Hatası
            </p></a>
          <b-avatar-group size="0">
            <b-avatar />
          </b-avatar-group>
        </app-timeline-item>
        <!--/ timeline -->
      </app-timeline></b-card-body>
    <div
      id="kay"
      class="md-3"
    >
      <a href="/table/bs-table">
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="secondary"
          block
        >
          Tümünü Gör
        </b-button></a></div>
  </b-card>

</template>

<script>
import {
  BCard, BCardBody, BButton, BCardHeader, BCardTitle, BImg, BMedia, BMediaBody, BMediaAside, BAvatar, BAvatarGroup, VBTooltip,
} from 'bootstrap-vue'
import AppTimeline from '@core/components/app-timeline/AppTimeline.vue'
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem.vue'
/* eslint-disable global-require */
export default {
  components: {
    BCard,
    BImg,
    BCardBody,
    BCardHeader,
    BCardTitle,
    AppTimeline,
    AppTimelineItem,
    BMedia,
    BAvatar,
    BMediaBody,
    BMediaAside,
    BButton,
    BAvatarGroup,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
}
</script>
<style>
#kay{
    border: none;

    color: white;

    padding: 15px 32px;

    text-align: center;

    text-decoration: none;

    display: inline-block;

    font-size: 16px;

    margin: 4px 2px;

    cursor: pointer;

}

</style>
